import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import CashEditDeleteLogLayer from "../../components/Utilities/CashEditDeleteLogLayer";
import Breadcrumb from "../../components/Breadcrumb";

const CashEditDeleteLogPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Cash Edit Delete Log" />
      <CashEditDeleteLogLayer />
    </MasterLayout>
  );
};

export default CashEditDeleteLogPage;
